"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keywordId = void 0;
const md5 = require("md5");
function keywordId(keyword) {
    return `k${md5(keyword)}`;
}
exports.keywordId = keywordId;
//# sourceMappingURL=keywordId.js.map